import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=4c60baf5&scoped=true&"
import script from "./ListComponent.vue?vue&type=script&lang=js&"
export * from "./ListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListComponent.vue?vue&type=style&index=0&id=4c60baf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60baf5",
  null
  
)

export default component.exports